import { render, staticRenderFns } from "./rss2.vue?vue&type=template&id=bf9289d4&"
import script from "./rss2.vue?vue&type=script&lang=js&"
export * from "./rss2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports